import type {Relation} from "typeorm";
import {Column, Entity, ManyToOne, OneToMany, RelationId, TableInheritance} from "typeorm";
import {BaseEntity} from "@/modules/base/entity";
import {MaxLength} from "class-validator";
import {Region} from "@/modules/base/entity/Region";
import {Country} from "@/modules/base/entity/Country";
import {Division} from ".";
import {Team} from "@/modules/team/entity";

@Entity()
@TableInheritance({column: {type: "varchar", name: "type"}})
export class Competition extends BaseEntity {
  @Column({type: 'varchar', length: '50'})
  @MaxLength(50)
  name: string;

  @ManyToOne(() => Region)
  region?: Relation<Region>;

  @ManyToOne(() => Country, {eager: true})
  country?: Relation<Country>;

  @OneToMany(() => Division, division => division.competition, {eager: true})
  divisions: Relation<Division[]>;

  @ManyToOne(() => Team, {nullable: true})
  winner?: Relation<Team>;

  @RelationId((m: Competition) => m.winner)
  winnerId?: number;
}
